<template>
  <formulaire-view
    :steps="steps"
    :step="step"
    url="/demande-changement-categorie-assurance/"
    paramsName="changement_categorie_assurance"
    :endpoint="endpoint"
    showPanier
    :getRefs="$refs"
  >
    <template v-slot:step="{ sas, path, setState, code }">
      <component 
        :is="path" 
        :sas="sas" 
        @validation-changed="setState(path, $event)" 
        :ref="path" 
        :endpoint="endpoint"
      >
        <ressource :code="code" />
      </component>
    </template>
  </formulaire-view>
</template>

<script>
import FormulaireView from "@/views/FormulaireView.vue"

import Identification from "@/components/Formulaires/DemandeChangementCategorieAssurance/Identification"
import ChangementCategorie from "@/components/Formulaires/DemandeChangementCategorieAssurance/ChangementCategorie"
import Declarations from "@/components/Formulaires/DemandeChangementCategorieAssurance/Declarations"

export default {
  props: {
    step: String
  },
  data() {
    return {
      endpoint: "demande-changement-categorie-assurance",
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "identification", code: "titre-etape-1", state: "" },
        { path: "changement-categorie", code: "titre-etape-2", state: "" },
        { path: "declarations", code: "titre-etape-6", state: "" },
        { path: "soumission", code: "titre-soumission" }
      ]
    }
  },

  components: {
    FormulaireView,
    Identification,
    ChangementCategorie,
    Declarations
  }
}
</script>
